import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { AuthContext } from "../../AuthProvider/AuthProvider";

const SocialLogin = () => {
  const { googleSignIn } = useContext(AuthContext);
  const navigate = useNavigate();
  const [error, setError] = useState();
  
  
  const handleGoogleSignIn = () => {
    googleSignIn()
      .then((res) => {
        const user = res.user;
        if (user) {
            navigate("/");
            setError("");
        }
      })
      .catch((err) => setError(err.message));
  };

  return (
    <div className="mx-auto">
      {error ? <p className="text-red-600">{error}</p> : ""}
      <button
        onClick={handleGoogleSignIn}
        className="btn btn-sm gap-2 mt-2 mb-6 bg-white text-black hover:text-white"
      >
        <img
          className="w-6 h-6"
          src="https://upload.wikimedia.org/wikipedia/commons/thumb/5/53/Google_%22G%22_Logo.svg/800px-Google_%22G%22_Logo.svg.png"
          alt=""
        />
        Continue with Google
      </button>
    </div>
  );
};

export default SocialLogin;
